<fieldset
  class="radio-fieldset"
  [attr.data-layout]="layout"
  [attr.data-size]="size"
  [attr.data-disabled]="disabled"
  [attr.data-error]="error"
  [attr.aria-required]="required"
  [disabled]="disabled"
>
  <legend *ngIf="label" class="radio-fieldset-legend">
    <umss-label
      [text]="label"
      [required]="required"
      size="Regular"
      weight="Medium"
    >
    </umss-label>
  </legend>

  <div class="radio-fieldset-items">
    <ng-content></ng-content>
  </div>

  <p *ngIf="helperText" class="radio-fieldset-helper">
    {{ helperText }}
  </p>
</fieldset>
